/**
 * @description Component-EarnLiquidities
 */
import './index.less';

import React, { FC } from 'react';

import SkeletonTable, { SkeletonTableColumnsType } from '@/components/SkeletonTable';
import Table from '@/components/Table';
import { WrappedRange } from '@/entities/WrappedRange';
import { useCurrentRange } from '@/features/account/rangeHook';
import { usePairFromUrl } from '@/features/pair/hook';

import { useChainId, useUserAddr } from '@/hooks/web3/useChain';

import { useMockDevTool } from '@/components/Mock';
import { EARN_TYPE } from '@/constants/earn';
import { PAIR_PAGE_TYPE } from '@/constants/global';
import { TRADE_OVERLAY_TYPE } from '@/constants/trade';
import { resetLiquidityFormByChainId, setEarnFormType } from '@/features/earn/action';
import { useFetchPortfolioListFromApi } from '@/features/portfolio/query';
import { useTradeStore } from '@/features/trade/store';
import { useAppDispatch } from '@/hooks';
import { useFilteredLiquidities } from '@/hooks/trade/useFilteredLiquidities';
import { useSideNavigate } from '@/hooks/useRouterNavigate';
import { TabKeys } from '@/pages/trade/TradePortfolio/TradePortfolioTabs';
import { useTranslation } from 'react-i18next';
import { useLiqTableColumns } from './tableTitles';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
  isTradePage?: boolean;
}
const EarnLiquidities: FC<IPropTypes> = function ({ isTradePage = true }) {
  const columnDefs = useLiqTableColumns();
  const chainId = useChainId();
  const { t } = useTranslation();
  const userAddr = useUserAddr();
  const currentPair = usePairFromUrl(chainId);
  const currentRange = useCurrentRange(chainId, userAddr);
  const rangeList = useFilteredLiquidities(currentPair, isTradePage);
  const { isFetched: isFetchedPortfolio } = useFetchPortfolioListFromApi(chainId, userAddr);
  const { isMockSkeleton } = useMockDevTool();
  const { pairPageNavigate } = useSideNavigate();
  const { setShowTradeAreaOverlay } = useTradeStore();
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  // const goToOrders = useCallback(() => {
  //   navigate(`/portfolio/${PORTFOLIO_TAB_ITEMS.PORTFOLIO}`);
  // }, [navigate]);
  // const { t } = useTranslation();
  // if (isFetchedPortfolio && !rangeList?.length) {
  //   return null;
  // }
  return (
    <div className="syn-earn-liquidities-wrap">
      {/* <div className="syn-earn-liquidities-wrap-title">
        {t('common.myLiquidity')}
        <Button size="small" onClick={goToOrders} type="text">
          {' '}
          {t('common.tradePage.allL')}
          <ChevronRight />
        </Button>
      </div> */}
      <SkeletonTable
        rowCount={2}
        loading={isMockSkeleton || !isFetchedPortfolio}
        columns={columnDefs as SkeletonTableColumnsType[]}>
        <Table
          className="syn-earn-liquidities"
          columns={columnDefs}
          dataSource={rangeList}
          pagination={false}
          rowKey={(record) => record.id}
          sticky={{ offsetHeader: 0 }}
          emptyDesc={t('common.empty.EarnNow')}
          emptyDescLink={window.location.href}
          emptyDescLinkClick={() => setShowTradeAreaOverlay(TRADE_OVERLAY_TYPE.ADD_LIQ)}
          scroll={{ y: isTradePage ? 430 : 400, x: 650 }}
          onRow={(record: WrappedRange) => ({
            onClick: () => {
              pairPageNavigate(record.rootPair.symbol, PAIR_PAGE_TYPE.EARN, undefined, {
                state: {
                  tab: TabKeys.LIQUIDITY,
                },
              });
              setShowTradeAreaOverlay(TRADE_OVERLAY_TYPE.ADD_LIQ);
              if (chainId) {
                dispatch(
                  setEarnFormType({
                    chainId,
                    formType: EARN_TYPE.ADD_LIQ,
                  }),
                );
                dispatch(resetLiquidityFormByChainId({ chainId }));
              }
            },
          })}
          rowClassName={(record: WrappedRange) =>
            record.id === currentRange?.id ? 'syn-earn-liquidities-row-active' : ''
          }
        />
      </SkeletonTable>
    </div>
  );
};

export default EarnLiquidities;
